import { Component, HostBinding, inject } from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

export interface WarningModalParams {
  cancelLabel: string;
  confirmLabel: string;
  header: string;
  maxWidth: number;
  message: string;
}

@Component({
  imports: [IconComponent, ButtonComponent],
  styles: [
    `
      :host {
        @apply block bg-white;
      }
    `,
  ],
  template: `
    <div class="px-[16px] pb-[12px] pt-[24px]">
      <div class="flex items-center justify-center">
        <aux-icon name="AlertTriangle" class="text-aux-red-dark" />
      </div>
      <div class="mt-[8px] text-center text-[24px] font-bold">
        {{ header }}
      </div>
      <div class="mt-[30px] max-w-2xl text-center">
        {{ message }}
      </div>
    </div>
    <div class="flex items-center justify-between border-t p-[16px]">
      <aux-button
        [label]="cancelLabel"
        (clickEmit)="onCancel()"
        variant="hyperlink"
        classList="text-aux-gray-darkest no-underline"
      />
      <aux-button [label]="confirmLabel" (clickEmit)="onConfirm()" variant="negative" />
    </div>
  `,
})
export class WarningModalComponent {
  cancelLabel = 'Cancel';
  confirmLabel = 'Confirm';
  header = '';
  @HostBinding('style.maxWidth.px')
  maxWidth: null | number = null;
  message = '';

  private ref =
    inject<CustomOverlayRef<'cancel' | 'confirm', WarningModalParams>>(CustomOverlayRef);

  constructor() {
    const data = this.ref.data;

    if (!data) {
      return;
    }

    this.header = data.header;
    this.message = data.message;
    this.cancelLabel = data.cancelLabel;
    this.confirmLabel = data.confirmLabel;
    this.maxWidth = data.maxWidth || null;
  }

  onCancel() {
    this.ref.close('cancel');
  }

  onConfirm() {
    this.ref.close('confirm');
  }
}
